import { mergeAttributes } from '@tiptap/core'
import TableCell from '@tiptap/extension-table-cell'
import { VueNodeViewRenderer } from '@tiptap/vue-3'

import { DATA_OBOARD_UID } from '@/utils/uid'

// eslint-disable-next-line import/extensions
import CustomTableCellTiptap from '@/components/TipTapExtensions/Table/CustomTableCellTiptap.vue'

export const TiptapTableCell = TableCell.extend({
  name: 'tableCell',
  addAttributes() {
    return {
      ...this.parent?.(),
      [DATA_OBOARD_UID]: {
        default: '',
        parseHTML: element => element.getAttribute(DATA_OBOARD_UID),
        renderHTML: attributes => {
          return {
            [DATA_OBOARD_UID]: attributes[DATA_OBOARD_UID]
          }
        }
      }
    }
  },
  parseHTML() {
    return [
      {
        // Do not change this name its reserved name for correct parsing HTML. If you change this name it will be break all saved table in each objective
        tag: 'vue-component-oboard-cell',
        getAttrs: dom => ({
          [DATA_OBOARD_UID]: dom.getAttribute(DATA_OBOARD_UID)
        })
      }
    ]
  },
  renderHTML({ HTMLAttributes }) {
    // Do not change this name and structure
    return ['td', ['vue-component-oboard-cell', mergeAttributes(HTMLAttributes), 0]]
  },
  addNodeView() {
    return VueNodeViewRenderer(CustomTableCellTiptap)
  }
})

export default TiptapTableCell
